import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/feature/JsonLd';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import BrandNarrative from './components/BrandNarrative';
import ArticleHub from './components/ArticleHub';
import CTASection from './components/CTASection';
import TestimonialSection from './components/TestimonialSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://oopbuyspreadsheets.monster';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'OOPBuy Spreadsheet',
  url: siteUrl,
  description: 'OOPBuy Spreadsheet is your smart bridge to curated sourcing. Browse 14 verified product categories including shoes, hoodies, t-shirts, jackets, and accessories. Save time with structured product tracking methodology and data-driven sourcing workflows.',
  inLanguage: 'en',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?s={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'OOPBuy Spreadsheet',
  url: siteUrl,
  description: 'A structured product sourcing hub connecting e-commerce sellers to 14 verified product categories on kaspreadsheet.com. Built on a data-driven sourcing methodology commonly used in e-commerce workflows.',
  sameAs: [
    'https://kaspreadsheet.com/',
  ],
};

export default function Home() {
  return (
    <>
      <JsonLd data={websiteJsonLd as Record<string, unknown>} />
      <JsonLd data={organizationJsonLd as Record<string, unknown>} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <BrandNarrative />
        <ArticleHub />
        <CTASection />
        <TestimonialSection />
      </main>
      <Footer />
    </>
  );
}